/**
 * The nav path that best matches `pathname`: an exact match or a nested screen
 * under it (ex: /monitors/5 keeps Monitors selected). The longest match wins,
 * so /automations/backtests does not also light up /automations. `/` only ever
 * matches exactly.
 */
export function matchActivePath(pathname, paths) {
    let active = null;
    for (const to of paths) {
        const matches =
            to === '/'
                ? pathname === '/'
                : pathname === to || pathname.startsWith(to + '/');
        if (matches && (active === null || to.length > active.length))
            active = to;
    }
    return active;
}

/**
 * Whether the best match for `pathname` is one of `groupPaths`, i.e. the current
 * screen lives inside that sidebar group. Used to keep the parent group
 * expanded so its selected subitem stays visible.
 */
export function isActiveInGroup(pathname, groupPaths, paths) {
    const active = matchActivePath(pathname, paths);
    return active !== null && groupPaths.includes(active);
}
